<template>
    <div>
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="listing-header columns is-flex is-flex-column">
                <div class="header-buttons column mr-3 is-100 is-flex is-flex-hright">
                    <button
                        v-if="permissao.update"
                        @click="save()"
                        :disabled="isSaving"
                        class="save-btn is-100 is-flex is-flex-vcenter is-flex-hcenter"
                        type="button"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>

                <div class="file-picker-input column">
                    <ImgPicker
                        v-if="permissao.create || permissao.update"
                        ref="filePicker"
                        class="upload-picker"
                        title=""
                        hidePreview
                        @uploadedFiles="getImagens"
                        isStrict
                        :customMaxImageWidth="1905"
                        :customMaxImageHeight="570"
                        :dataImage="{
                            largura: '1905',
                            altura: '570',
                            size: '2MB',
                        }"
                    />
                </div>

                <div class="column pb-4">
                    <b-skeleton width="100%" height="25%" :active="isSaving"></b-skeleton>

                    <div class="grid-container" ref="PackeryMagic" v-if="!isSaving">
                        <div
                            v-for="(banner, key) in B2BClienteBanner"
                            :key="key"
                            class="is-flex is-flex-column grid-item mb-4"
                            ref="gridItem"
                            :data-item="JSON.stringify(banner)"
                        >
                            <container-loader v-if="banner.isUpdating" />
                            <div
                                class="image-header is-default-table-border is-flex is-flex-hbetween is-flex-vcenter"
                            >
                                <span class="is-flex">
                                    {{
                                        banner.id
                                            ? banner.url.split('/').at(-1)
                                            : banner.mediaFile.fileName
                                    }}
                                    <p v-if="!banner.id" class="new-color ml-2">
                                        {{ $t('novo') }}!
                                    </p>
                                </span>
                                <button
                                    v-if="permissao.delete"
                                    @click="
                                        banner.id
                                            ? promptChangeSituacao(banner)
                                            : removerNovaImagem(banner.idImagem)
                                    "
                                    class="btn btn-custom-size"
                                    :class="{
                                        'activate-button': banner.situacao === 0,
                                        'delete-color': banner.situacao === 1,
                                    }"
                                    type="button"
                                >
                                    <b-icon
                                        :icon="banner.situacao === 1 ? 'delete' : 'check'"
                                        type="is-white"
                                    >
                                    </b-icon>
                                </button>
                            </div>
                            <img
                                :src="banner.url"
                                alt="Banner empresa"
                                class="image-size"
                                :class="{ 'image-disabled': banner.situacao === 0 }"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import B2BClienteSovisBannerService from '@/services/b2b/B2BClienteSovisBannerService';
import ImgPicker from '@/components/shared/form/ImgPicker';
import $ from 'jquery';
import * as Draggable from 'jquery-ui/ui/widgets/draggable.js';
import Packery from 'packery';

export default {
    components: {
        ContainerLoader,
        ImgPicker,
    },
    data() {
        return {
            permissao: {},
            isLoading: false,
            isBannerLoading: false,
            isSaving: false,
            B2BClienteBanner: [],
            imagens: [],
            bannerSelecionado: null,
            packery: null,
            packeryOpts: {
                itemSelector: '.grid-item',
                transitionDuration: '0.3s',
            },
            dragOpts: {
                containment: '.grid-container',
                gutter: 40,
            },
            jQuery: $,
            service: new B2BClienteSovisBannerService(this.$http, this.$router),
            isEmpty: false,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('b2b', 'b2b-parametrizacoes-edit');

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'banner' },
            });
        } else {
            this.carregarDados();
        }
    },
    methods: {
        carregarDados() {
            this.isLoading = true;

            this.service
                .findAll()
                .then(({ content }) => {
                    this.B2BClienteBanner = content.map((banner) => ({
                        ...banner,
                        isUpdating: false,
                    }));

                    this.isEmpty = content.length <= 0;
                    setTimeout(() => {
                        this.setDraggable();
                    }, 300);
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        save() {
            this.isSaving = true;

            this.B2BClienteBanner = this.packery.getShiftPositions('data-item');

            new Promise((resolve) => {
                this.B2BClienteBanner.forEach((banner, index) => {
                    const imagem = this.imagens.find(
                        (imagem) => imagem.idImagem === banner.idImagem
                    );

                    this.service.save(imagem, banner).then(() => {
                        if (index + 1 === this.B2BClienteBanner.length) {
                            resolve();
                        }
                    });
                });
            })
                .then(() => {
                    this.$root.showMessage('success', 'msg-sucesso-banner');

                    setTimeout(() => {
                        this.B2BClienteBanner = [];
                        this.isSaving = false;
                        this.carregarDados();
                    }, 300);
                })
                .catch(() => {
                    this.$root.showMessage('error', 'msg-erro-salvar');
                });
        },
        setDraggable() {
            if (this.packery) this.packery.destroy();

            this.packery = new Packery(this.$refs.PackeryMagic, this.packeryOpts);

            const gridItem = this.$refs.gridItem;

            if (gridItem) {
                gridItem.forEach((item) => {
                    item.draggable = new Draggable(this.dragOpts, item);
                    this.bindDraggables(item);
                });
            }

            Packery.prototype.getShiftPositions = function (attrName) {
                return this.items.map((item, index) => {
                    const bannerObjeto = JSON.parse(item.element.getAttribute(attrName));
                    const ordem = index + 1;

                    return {
                        ...bannerObjeto,
                        ordem,
                    };
                });
            };
        },
        bindDraggables(item) {
            this.jQuery(item).on('dragstart', this.packery.handleUIDraggable.start);
            this.jQuery(item).on('drag', this.packery.handleUIDraggable.drag);
            this.jQuery(item).on('dragstop', this.packery.handleUIDraggable.stop);
        },
        promptChangeSituacao(banner) {
            this.bannerSelecionado = banner;

            const message = this.$t(
                'msg-confirmacao-desativacao-n', 
                { n: banner.url.split('/').at(-1) }
            );

            this.$root.confirm({
                message: message,
                onConfirm: this.mudarSituacao,
            });
        },
        mudarSituacao() {
            const indexBannerAtualizado = this.B2BClienteBanner.findIndex(
                (banner) => banner.id === this.bannerSelecionado.id
            );

            const bannerNoArray = this.B2BClienteBanner.at(indexBannerAtualizado);

            bannerNoArray.isUpdating = true;

            this.service
                .updateSituacao(this.bannerSelecionado)
                .then((response) => {
                    const isBannerAtivo = this.bannerSelecionado.situacao;

                    this.$root.showMessage(
                        'success',
                        isBannerAtivo
                            ? 'msg-sucesso-ao-desativar-banner'
                            : 'msg-sucesso-ao-ativar-banner'
                    );

                    bannerNoArray.situacao = isBannerAtivo === 1 ? 0 : 1;
                })
                .catch((error) => {
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                })
                .finally((_) => {
                    bannerNoArray.isUpdating = false;
                });
        },
        getImagens(imagens) {
            this.isSaving = true;

            new Promise((resolve) => {
                imagens.forEach((imagem) => {
                    const novoBanner = {
                        clienteSovisId: this.$store.state.user.idClienteSovis,
                        id: 0,
                        isUpdating: false,
                        ordem: this.B2BClienteBanner.length + 1,
                        situacao: 1,
                        url: imagem.imgurl,
                        mediaFile: imagem,
                        idImagem: this.imagens.length + 1,
                    };

                    this.B2BClienteBanner.push(novoBanner);

                    this.imagens.push({
                        idImagem: this.imagens.length + 1,
                        file: imagem.file,
                    });
                });

                resolve();
            })
                .then(() => {
                    this.isSaving = false;
                })
                .then(() => {
                    setTimeout(() => {
                        this.setDraggable();
                    }, 300);
                });
        },
        removerNovaImagem(idImagem) {
            this.isSaving = true;

            new Promise((resolve) => {
                const indexBannerASerRemovido = this.B2BClienteBanner.findIndex(
                    (banner) => banner.idImagem === idImagem
                );

                this.B2BClienteBanner.splice(indexBannerASerRemovido, 1);

                const indexImagemASerRemovido = this.imagens.findIndex(
                    (imagem) => imagem.idImagem === idImagem
                );

                this.imagens.splice(indexImagemASerRemovido, 1);

                resolve();
            })
                .then(() => {
                    this.isSaving = false;
                })
                .then(() => {
                    this.setDraggable();
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.save-btn {
    width: 212px;
}

.btn-custom-size {
    padding: 0.35rem;
    height: max-content;
}

.new-color {
    color: #4caf50;
}

.delete-color {
    background-color: #f44336;
}

.activate-button {
    background-color: #4caf50;
}

.image-disabled {
    filter: brightness(0.3);
    transition: 300ms ease-in-out;
}

.image-disabled:hover {
    filter: brightness(1);
}

.g-4 {
    gap: 2rem;
}

.image-size {
    aspect-ratio: 3.34/1;
    width: 1905px;
    min-width: 100%;
}

.image-header {
    padding: 1rem 1.5rem 1rem 1.5rem;
    background-color: white;
}

.grid-item {
    cursor: grab;
}
</style>
